// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"SidebarVideoSquirrelLogo_logoWrapper__Etr5z","logo":"SidebarVideoSquirrelLogo_logo__eP7sf"};